'use client'
import { HTMLAttributes, useContext } from 'react'
import styles from './WysiwygContent.module.scss'
import { classNames } from '@/src/helpers/component'
import { Dict } from '@/src/helpers/common.types'
import { Site_Settings } from '@/src/generated/graphql'
import { DirectusContext } from '@/src/contexts/DirectusContext'
import parse from 'node-html-parser'

const keywordReplacements = (
  original: string,
  replacements: { siteSettings: Partial<Site_Settings> },
) => {
  const replacementMap: Dict<string> = {
    WORK_WITH_US_EMAIL: replacements.siteSettings.work_with_us_email ?? '',
    //...
    // TODO: ADD MORE KEYWORDS HERE
    // keywords that are more likely to be used in the wysiwyg content
    // keywords are case-sensitive, and are in the format of: "[" + keyword + "]"
  }

  return original.replaceAll(
    new RegExp(`\\[(${Object.keys(replacementMap).join('|')})\\]`, 'g'),
    (...matches) => replacementMap[matches[1]] ?? '',
  )
}

// fixes the anchor menu content overflow issue -- caused by the <table> in the wysiwyg content
// add a div wrapper around the table to make it scrollable
const scrollableTable = (content: string) => {
  const dom = parse(content)
  const $tables = dom.querySelectorAll('table')
  $tables.forEach($table => {
    $table.replaceWith(`<div class="--scrollable">${$table.outerHTML}</div>`)
  })
  return dom.innerHTML
}

const responsiveYoutubeEmbed = (content: string) => {
  const dom = parse(content)
  const $ytIframes = dom.querySelectorAll('iframe[src*="youtube"]')
  $ytIframes.forEach($iframe => {
    $iframe = $iframe.setAttribute(
      'class',
      ($iframe.getAttribute('class') ?? '') + ` ${styles.videoIframe}`,
    )
    $iframe.replaceWith(`<div class="${styles.videoContainer}">${$iframe.outerHTML}</div>`)
  })
  return dom.innerHTML
}

export default function WysiwygContentClient({
  content,
  ..._
}: HTMLAttributes<HTMLDivElement> & { content: string }) {
  const directusContext = useContext(DirectusContext)

  content = scrollableTable(content)
  content = responsiveYoutubeEmbed(content)
  content = keywordReplacements(content, { siteSettings: directusContext.SITE_SETTINGS })
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      {..._}
      className={classNames(styles.container, _.className)}
    />
  )
}